<template>
  <div ref="TreeChart" style="width: 100%; height: 100%" @wheel.prevent></div>
</template>

<script>
import * as echarts from "echarts";
import { px2rem } from "@/utils/rem";
import { generateTreeChartTooltip } from "@/utils/tooltip";

export default {
  name: "TreeChart",
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
  emits: ["finished"],
  watch: {
    data: {
      handler() {
        this.chart && this.chart.dispose();
        this.init();
      },
      deep: true,
    },
  },
  data() {
    return {
      chart: null,
    };
  },
  mounted() {
    // this.init();
  },
  methods: {
    init() {
      let option = {
        tooltip: {
          trigger: "item",
          triggerOn: "mousemove",
          backgroundColor: "transplant",
          borderColor: "transplant",
          borderWidth: 0,
          padding: 0,
          formatter: function (params) {
            return generateTreeChartTooltip({
              name: params.name,
              value: params.value,
              primaryColor: params.color,
              borderColor: params.color,
            });
          },
        },
        series: [
          {
            type: "tree",
            initialTreeDepth: 3,
            data: this.data,
            roam: true,
            top: "1%",
            left: "10%",
            bottom: "1%",
            right: "10%",
            symbolSize: px2rem(14),
            labelLayout: {
              hideOverlap: true,
            },
            label: {
              position: "left",
              verticalAlign: "middle",
              align: "right",
              fontSize: px2rem(12),
            },
            leaves: {
              label: {
                position: "right",
                verticalAlign: "middle",
                align: "left",
              },
            },
            emphasis: {
              focus: "descendant",
            },
            expandAndCollapse: true,
            animationDuration: 480,
            animationDurationUpdate: 750,
          },
        ],
      };
      this.chart = echarts.init(
        this.$refs.TreeChart,
        {},
        {
          renderer: "svg",
        }
      );
      this.chart.setOption(option);
      this.chart.on("finished", () => {
        this.$emit("finished");
        this.chart.off("finished");
      });
    },
  },
  beforeDestroy() {
    // 在组件销毁前，销毁 ECharts 实例
    this.chart && this.chart.dispose();
  },
};
</script>

<style lang="scss" scoped></style>
